import React from "react";
import LEFT from './../../assets/images/left.svg';
import RIGHT from './../../assets/images/right.svg';
import {useDispatch} from "react-redux";
const MobileBottomPagination = (props) => {
    const dispatch = useDispatch();
    const {
        api,
        total,
        per_page,
        current
    } = props;
    const getPrevPage = () => {
        if (current <= 1)
            return 1;
        return current-1;
    };
    const getNextPage = () => {
        if (current >= Math.ceil((total/per_page)))
            return current;
        return current+1;
    }; 
    return (
        <>
            <div className={props.className ? props.className : "mobile-bottom-navigation-holder"}>
                <div className="mobile-bottom-navigation-item" onClick={() => dispatch(api({per_page,page:Math.ceil((total/per_page))}))}>
                    <img src={RIGHT} alt="" width={20}  style={{marginLeft:'-12px'}}/>
                    <img src={RIGHT} alt="" width={20}/>
                </div>
                <div className='separator' />
                <div className="mobile-bottom-navigation-item"  onClick={() => dispatch(api({per_page,page:getNextPage()}))}>
                    <img src={RIGHT} alt="" width={20}/>
                </div>
                <div className='separator' />
                <div className='mobile-bottom-navigation-item'>
                    <img src={LEFT} alt="" width={20} onClick={() => dispatch(api({per_page,page:getPrevPage()}))}/>
                </div>
                <div className='separator' />
                <div className='mobile-bottom-navigation-item' onClick={() => dispatch(api({per_page,page:1}))}>
                    <img src={LEFT} alt="" width={20} style={{marginLeft:'-12px'}}/>
                    <img src={LEFT} alt="" width={20}/>
                </div>
            </div>
        </>
    )
};

export default MobileBottomPagination;